export class product_add_comment_controller {
    rateTypes = [];
    comment;
    user;
    rateAjaxLoding;
    commentAjaxLoding;
    slider_ticks = {
        value: 3,
        options: {
            ceil: 5,
            floor: 0,
            showTicks: true,
            showSelectionBar: true
        }
    };
    constructor(private $rate, private $comment, private $user, private $state, private $notify) {
        "ngInject"

    }

    $onInit() {

        // this.$user.getInfo().then(
        //     user => {
        //         if (user.data) {

        //             this.user = user;
        //             this.comment = {
        //                 ProductID: this.$state.params.pID,
        //                 UserName: this.user.DisplayName,
        //                 Comment: "",
        //             }
        //         }
        //     }
        // )

        this.$rate.productRate((res) => {
            res.map((item) => {
                item.value = 3;
                this.rateTypes.push(item)
            })
        })
    }
    focusOnForm($event) {

    }
    sendComment() {
        this.commentAjaxLoding = true;
        this.comment.productId = this.$state.params.pID

        this.$comment.insert(this.comment,
            respone => {
                this.$notify.show({ text: 'با تشکر! نظر شما با موفقیت ثبت شد' })
                this.comment.Comment = null
                this.commentAjaxLoding = false;

            },
            reject => {

            }
        )
    }

    rate() {
        this.$user.getInfo().then(
            user => {
                if (user.data) {
                    this.rateAjaxLoding = true;
                    let rates = [];
                    this.rateTypes.map((item) => {
                        let rate = {
                            ID: this.$state.params.pID,
                            Rate: item.value * 20,
                            RateType: item.TypeID
                        }
                        rates.push(rate)
                    })
                    this.$rate.vote(rates,
                        response => {
                            this.$notify.show({ text: 'امتیاز شما با موفقیت ثبت شد' })
                            this.rateAjaxLoding = false;
                        }
                    )
                } else {
                    this.$user.showLogin()
                }
            }
        )

    }
}


// WEBPACK FOOTER //
// ./src/components/product-add-comment/product-add-comment.controller.ts